import { useEffect } from "react";
import { getEngine } from "../context/commerce-engine-csr";
import useOneTrust from "@greystar/ui/src/hooks/useOneTrust";

export const useCoveoAnalytics = () => {
  const { consentGroups } = useOneTrust();

  useEffect(() => {
    const engine = getEngine();

    if (consentGroups["performance"]) {
      engine.enableAnalytics();
    } else {
      engine.disableAnalytics();
    }
  }, [consentGroups]);
};
